export const audioFileFormats =
  'audio/mpeg, audio/mp4, audio/m4a, audio/x-m4a, audio/ogg, audio/flac, audio/aac, audio/wav';
